// @flow
import React, { PureComponent } from 'react';
import { groupBy } from 'lodash';

import { parseHTMLEntity } from 'utils/documentsUtils';
import { getMonthName } from 'utils/dateUtils';

import EventListElementWrapper from 'components/event/EventListElementWrapper';
import HiddenEventListElement from 'components/event/HiddenEventListElement';

import type { EventType, EventMatchType } from 'types/Event';
import type { CompetitionEquipeType } from 'types/Settings';

export type StateProps = {
  competitionsEquipes: CompetitionEquipeType,
};

type OwnProps = {
  events: Array<EventType | EventMatchType>
};

type Props = OwnProps & StateProps;
type State = {
  isOpen: boolean
};
class EventListRow extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    isOpen: false
  };
  renderTitle = (teams: { team: string, matchs: number }[]): string[] => {
    return teams.map(({ team, matchs }, i) =>
      (`${team}: ${matchs}`)
    );
  };

  handleHiddenOpen = (e: MouseEvent) => {
    e.preventDefault();
    this.setState(({ isOpen: prevIsOpen }) => ({ isOpen: !prevIsOpen }));
  };

  renderFirstEvents = (type: 'matchEvents' | 'classicEvents', events: Array<EventType | EventMatchType>): React$Node => {
    const { competitionsEquipes } = this.props;
    const { startDate } = events[0];
    const isMatchEvent = type === 'matchEvents';
    const groupByTeam = groupBy(events, 'compID');
    let teamNames = [];
    if (isMatchEvent) {
      teamNames = Object.keys(groupByTeam)
        .map(compID => ({
          team: parseHTMLEntity(competitionsEquipes[compID].equipe_nom),
          matchs: groupByTeam[compID].length,
        }));
    }

    return (
      <div className="event-row event-row--large">
        <p className="event__date">
          <span className="event__day ft-h2">{startDate.getDate()}</span>
          <br />
          <span className="event__month ft-h6 ft-up">{getMonthName(startDate.getMonth())}</span>
        </p>
        <div className="event__content">
          {isMatchEvent && <span className="label event__status mb-1">En cours</span>}
          <h2 className="event__title ft-h4">
          {/* eslint-disable-next-line */}
            <a title="Voir le contenu des évènements" onClick={this.handleHiddenOpen}>
              {isMatchEvent
                ?`${events.length} Matchs : ${this.renderTitle(teamNames).join(', ')}`
                : `${events.length} évènements`}
            </a>
          </h2>
        {isMatchEvent && <p><span className="event__type ft-h6 ft-up">Match</span></p>}
        </div>
      </div>
    );
  };

  render() {
    const { events } = this.props;
    const matchEvents = events.filter(event => Object.prototype.hasOwnProperty.call(event, 'compID'));
    const classicEvents = events.filter(event => !Object.prototype.hasOwnProperty.call(event, 'compID'));
    if (events.length === 0) return null;
    if (events.length === 1) return <EventListElementWrapper event={events[0]} isFirst />;
    if (events.length > 1 && matchEvents.length < events.length) return (
      <div className="events__group">
        {matchEvents.length > 1 && 
        this.renderFirstEvents('matchEvents', matchEvents) }
        {matchEvents.length > 1 && 
        <HiddenEventListElement events={matchEvents} areHiddenMatches forceOpen={this.state.isOpen} /> }
        {matchEvents.length === 1 && 
        <EventListElementWrapper event={matchEvents[0]} isFirst />}
        {classicEvents.length > 1 && 
        this.renderFirstEvents('classicEvents', classicEvents)}
        {classicEvents.length > 1 && 
        <HiddenEventListElement events={classicEvents} forceOpen={this.state.isOpen} /> }
        {classicEvents.length === 1 && 
        <EventListElementWrapper event={classicEvents[0]} isFirst />}
      </div>
    );
    return (
      <div className="events__group">
        {this.renderFirstEvents('matchEvents', matchEvents)}
        <HiddenEventListElement events={matchEvents} areHiddenMatches forceOpen={this.state.isOpen} />
      </div>
    );
  }
}

export default EventListRow;
